import { render, staticRenderFns } from "./VerticalMedias.vue?vue&type=template&id=538f0684"
import script from "./VerticalMedias.vue?vue&type=script&lang=js"
export * from "./VerticalMedias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports